import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';
import { ILowRateMortgagePromo } from '../../../types/promosPage';
import { IPage } from '../../../types/redux';

interface ITrackPromoClickParams {
  page: IPage;
  promo: ILowRateMortgagePromo;
}

export const trackPromoClick = ({ page, promo }: ITrackPromoClickParams) => {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'Promo',
    name: 'oldevent',
    label: 'low_mortgage_rates',
    page: {
      ...page,
      extra: {
        block: EPageBlock.LowMortgageRates,
        builder_id: promo.providerId,
        Promo_id: promo.providerPromoId,
      },
    },
  });
};
